module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    attrs: {
      "id": 'organization' + _vm.organization.organizationId
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectOrganization(_vm.organization.organizationId)
      }
    }
  }, [_vm._v(" \n    "), (_vm.hasChild) ? _c('span', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggle($event)
      }
    }
  }, [(_vm.open) ? _c('v-icon', {
    staticClass: "body-2 grey--text"
  }, [_vm._v("indeterminate_check_box")]) : _c('v-icon', {
    staticClass: "body-2 grey--text"
  }, [_vm._v("add_box")])], 1) : _c('span', [_vm._v("    ")]), _vm._v(" "), _c('v-icon', {
    staticClass: "body-2 blue-grey--text text--lighten-2"
  }, [_vm._v("folder")]), _vm._v(" "), _c('span', [_vm._v("\n      " + _vm._s(_vm.organization.name) + "\n      ")])], 1), _vm._v(" "), (_vm.hasChild) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }]
  }, _vm._l((_vm.organization.children), function(organization, index) {
    return _c('tree-view', {
      key: index,
      attrs: {
        "organization": organization
      },
      on: {
        "child-action": _vm.selectOrganization
      }
    })
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-3e5ab740","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TreeView.vue
// module id = 1919
// module chunks = 0